<skl-dialog-content-ins [isReady]="viewModel?.isFormReady">
	<skl-dialog-header-ins
		[title]="'scenes.shared.dialog.select-duplicated-client.title.duplicate-warning' | translate"
		id="select-duplicated-client-dialog-header"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<div class="align--form relative-height">
			<div class="col-1 align--big-bottom" id="select-duplicated-client-dialog-message">
				{{ 'scenes.shared.dialog.select-duplicated-client.form.duplicate-message' | translate }}
			</div>

			<skl-grid-ins
				[dataSource]="viewModel.gridDataSource$"
				id="select-duplicated-client-dialog-grid"
				[columns]="viewModel.gridColumns$"
				[options]="viewModel.gridOptions">
				<ng-template [sklGridTemplate]="'selectDuplicatedClientSelectTemplate'" let-row="row" let-col="col">
					<skl-button
						class="align--tiny"
						typeName="default"
						(click)="viewModel.onClientSelect(row)">
						<span class="text--font-smaller">
							{{ 'scenes.shared.dialog.select-duplicated-client.buttons.select' | translate }}
						</span>
					</skl-button>
				</ng-template>
			</skl-grid-ins>
		</div>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="select-duplicated-client-dialog-cancel-button"
			(click)="onCancel()">
			{{ 'scenes.shared.dialog.select-duplicated-client.buttons.cancel' | translate }}
		</skl-button>
		<skl-button
			typeName="accent"
			id="select-duplicated-client-dialog-confirm-button"
			(click)="save()">
			{{ 'scenes.shared.dialog.select-duplicated-client.buttons.use-existing' | translate }}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>